import { getCompanyInfo } from "./getCompanyInfo";

/** 开启点击行为日志上报 */
export const isEnableClickLog = () => ['localhost', 'app.cartsee.com'].includes(window.location.hostname);

/** 开启新服务 */
export const isEnableNewService = () => true;

export const isEnableWheelCouponSetting = () => {
  return true;
}

export const isEnablePopupCover = () => {
  return true;
};

export const isEnablePrivacySetting = () => {
  return true;
}

export const isEnableCombinedDiscountCode = () => {
  return true;
}

export const isEnablePopSetting = () => {
  return true;
};

export const isEnableAuth = () => {
  return [30, 328, 565, 621, 1227, 1533, 2224, 2346, 2347, 2348, 2349, 2350, 2351, 907, 2523, 2733, 1738, 3140, 3048, 1756, 1893, 3221, 1289, 1292, 1400, 1401, 1455, 1456, 1482, 1483, 1484, 1485, 2005, 3351, 3356, 2667].includes(getCompanyInfo().id as number);
};

/** 仅限新订阅用户发放券包 */
export const ONLY_NEW_USER_TPLID = ['126'];

export const isOnlyNewUserTemplate = (templateId?: string | number | null) => {
  return ONLY_NEW_USER_TPLID.includes(String(templateId || ''));
};

/** 大转盘模板 */
export const BIG_WHEEL_TPLID = ['1', '18'];

/** 多步骤采集模板 */
export const MULTI_STEP_TPLID = ['19', '20', '40', '41'];

export const DISABLE_SMS_SUBSCRIPTION_TPLID= [...ONLY_NEW_USER_TPLID, ...BIG_WHEEL_TPLID, ...MULTI_STEP_TPLID];

export const DISABLE_CUSTOM_STEP_TPLID = ['1', '18', '19', '20', '21', '22', '23', '24', '25', '26', '40', '41', '97', '116', '117', '118', '126'];

export const DISABLE_CUSTOM_STEP_TPLID_NEW = ['1', '18', '19', '20', '21', '22', '23', '24', '25', '26', '40', '41', '97', '116', '117', '118'];

export const SMB_GRAY_SHOPIFY_LIST = [1791,1790,1827,1828,1860,2671,2512,3001,3029,2626,2670,2111,2696,3203,2541,2373,12,2584,718,1501,1650,1507,1509,1917,1864,2040,1499,1834,1500,1620,1816,1817,1845,2751,2221,2079,1974,2205,1505,2527,1516,1515,2275,2423,2114,2738,2525,2453,1582,1333,2802,1767,2084,2764,1354,1534,56,2742,1840,2801,3193,29,1863,1819,1833,2339,3014,1508,1588,1532,1818,1043,2071,2693,2380,2231,2544,2509,2604,2741,2710,2740,2955,3112,3115,3127,3139,3149,3164,2080,2528,2496,2357,2039,2567,2247,2341,1960,1992,2038,2099,2410,2031,2036,2013,2020,2009,2032,2033,2035,2019,2024,2025,2001,61,1626,2255,2568,2615,31,2744,2734,2705,2735,2745,2704,2297,1372,1570,2202,1926,2985,3225,2861,3361,3315,2953,3399,3420,3433,3495];
// shopline shopify shoplazza SMB店铺id灰度列
export const SMB_GRAY_SHOLINE_LIST = [2260,2863,2862,2860,2606,2562,2502,2559,1730,1452,1632,1853,1856,1877,2815,2258,2245,1748,71,2237,3059,2378,2382,2822,2534,2002,3223,2787,2135,3261];
// SHOPLAZZA店铺id灰度列表
export const SMB_GRAY_SHOPLAZZA_LIST = [2438,1560,1543,1538,1843,1825,1537,1677,1586,1697,1961,2261,2226,1601,1815,2565,2605,1976,1962,2061,1540,1887,1988,1844,1888,1523,1542,1841,1539,1541,1680,1683,1826,1832,1914,1963,1965,2000,2824,2780,2758,3276,1842,1629,2094,1628,1590,1647,3052,2823,1276,2342,1327,1311,1063,1479,2585,3123,3128,3129,3130,2660,2577,2601,2737,2736,2663,2763,3249,2241,2905,3037,2546,2554,2555,2547,2690,2550,2788,2803,2851,2798,2819,2820,2869,3260,1228,2004,2566,2594,2595,3375,3500,3502,3505,3493,3497];
// KA 灰度列表
export const KA_GRAY_LIST = [3775, 173, 1931, 1738, 3048, 3140, 1691, 333, 332, 363, 2064, 52, 338, 1867, 2839, 340, 341, 682, 684, 1705, 1079, 1927, 360, 2730, 3160, 3171, 3174, 3176, 3177, 2533, 1837, 1924, 1801, 1821, 1820, 2030, 2074, 1275, 1368, 1496, 1506, 1673, 2818, 3024, 1967, 2049, 2050, 1439, 2051, 2747, 2748, 2654, 2655, 2700, 2760, 33, 1292, 1482, 1401, 1400, 1483, 1455, 1484, 1456, 1289, 1485, 2005, 1382, 2330, 2023, 1522, 1559, 2417, 2153, 2731, 3206, 3216, 3226, 3227, 3229, 3230, 3231, 3232, 3233, 2336, 2993, 3010, 3152, 1995, 2933, 2581, 2242, 2215, 2192, 2293, 2220, 2078, 2229, 2243, 2207, 2155, 2640, 2720, 2827, 2853, 2657, 2947, 2997, 3040, 3043, 1248, 1519, 2770, 2832, 2833, 2834, 2835, 2836, 2830, 2831, 2821, 2816, 1990, 2724, 2800, 889, 3271, 3275, 3124, 3248, 3629, 1472, 2303, 3099, 3148, 3175, 3180, 3184, 3187, 3202, 3228, 3346, 3353, 3371, 3372, 3435, 3482, 3483, 3484, 3630, 3637, 3638, 3640, 3642, 3646, 3652, 3475, 3570, 3567, 3309, 2091, 1836, 1351, 1381, 2709, 2580, 2618, 2708, 2619, 2195, 595, 327, 596, 1977, 915, 1320, 1307, 1313, 1317, 1316, 1315, 1318, 2225, 1237, 3535, 3688, 283, 329, 330, 331, 1355, 1526, 1060, 2540, 1530, 1405, 1028, 1078, 1606, 1361, 1030, 1061, 1324, 1325, 1326, 1329, 1335, 1356, 1358, 1399, 1402, 1406, 1407, 1408, 1438, 1584, 1585, 1599, 2630, 2852, 2721, 2722, 212, 533, 904, 1812, 1813, 1936, 1930, 1935, 343, 345, 349, 317, 321, 346, 348, 372, 413, 415, 424, 3347];

// KA shopify店铺id灰度列表
export const KA_GRAY_SHOPIFY_LIST = [173,1931,1738,3048,3140,1691,333,332,363,2064,52,338,1867,2839,340,341,682,684,1705,1079,1927,360,2730,3160,3171,3174,3176,3177,2533,1837,1924,1801,1821,1820,2030,2074,1275,1368,1496,1506,1673,2818,3024,1967,2049,2050,1439,2051,2747,2748,2654,2655,2700,2760,33,1292,1482,1401,1400,1483,1455,1484,1456,1289,1485,2005,1382,2330,2023,1522,1559,2417,2153,2731,3206,3216,3226,3227,3229,3230,3231,3232,3233,2336,2993,3010,3152,1995,2933,2581,2242,2215,2192,2293,2220,2078,2229,2243,2207,2155,2640,2720,2827,2853,2657,2947,2997,3040,3043,1248,1519,2770,2832,2833,2834,2835,2836,2830,2831,2821,2816,1990,2724,2800,889,3271,3275,3124,3248,3629,1472,2303,3099,3148,3175,3180,3184,3187,3202,3228,3346,3353,3371,3372,3435,3482,3483,3484,3630,3637,3638,3640,3642,3646,3652,3475,3570,3567,3309];

// KA shopline店铺id灰度列表
export const KA_GRAY_SHOLINE_LIST = [2091,1836,1351,1381,2709,2580,2618,2708,2619,2195,595,327,596,1977,915,1320,1307,1313,1317,1316,1315,1318,2225,1237,3535,3688];

// KA shoplazza店铺id灰度列表
export const KA_GRAY_SHOPLAZZA_LIST = [283,329,330,331,1355,1526,1060,2540,1530,1405,1028,1078,1606,1361,1030,1061,1324,1325,1326,1329,1335,1356,1358,1399,1402,1406,1407,1408,1438,1584,1585,1599,2630,2852,2721,2722,212,533,904,1812,1813,1936,1930,1935,343,345,349,317,321,346,348,372,413,415,424,3347];

// 首批小灰度列表
export const SMB_GRAY_SMALL_LIST = [30, 3243, 2512, 2801, 2802, 306, 621];

//  SMB灰度合集
export const SMB_GRAY_LIST = [...SMB_GRAY_SMALL_LIST, ...SMB_GRAY_SHOPIFY_LIST, ...SMB_GRAY_SHOLINE_LIST, ...SMB_GRAY_SHOPLAZZA_LIST];

// SKA灰度列表
export const SKA_GRAY_LIST = [328, 907, 1533];
// 新功能试点灰度
export const isNewFunctionGray = () => {
  return [...SMB_GRAY_LIST,...KA_GRAY_LIST, 3416].includes(getCompanyInfo().id as number);;
};

/** 动态折扣码高阶能力（折扣类型 / 生效范围 / 每笔一单次等）
 * 灰度条件：店铺在 SMB_GRAY_SMALL_LIST 中，且店铺渠道是 Shopify
 */
export const isWheelDiscountAdvancedGray = () => {
  const companyInfo = getCompanyInfo();
  return [30, 3243, 1756, 2512, 2802, 3654].includes(companyInfo.id as number);
};

const WHEEL_DISCOUNT_ADVANCED_FIELD_KEYS = [
  "discountCodeType",
  "scopeType",
  "collectionScope",
  "productScope",
  "oncePerOrder",
] as const;

/** 非灰度店铺提交或回显前移除高阶字段，避免散落 delete */
export function omitWheelDiscountAdvancedFields<T extends Record<string, any>>(data: T): T {
  const out = JSON.parse(JSON.stringify(data || {})) as T;
  WHEEL_DISCOUNT_ADVANCED_FIELD_KEYS.forEach((k) => {
    delete (out as any)[k];
  });
  return out;
}

export const isKAGray = () => {
  return [...SMB_GRAY_LIST, ...KA_GRAY_LIST].includes(getCompanyInfo().id as number);
}

export const isEnableCustomStep = () => {
  return true;
};

export const isEnableBannerEnglishPunctuationSpacing = () => {
  return [30, 3243, 2512, 2801, 2802, 328, 3416, ...SMB_GRAY_LIST, ...KA_GRAY_LIST].includes(getCompanyInfo().id as number);
};

export const isIconBeforeShowConfig = () => {
  return [30, 306, 621, 3416, ...SMB_GRAY_LIST, ...KA_GRAY_LIST].includes(getCompanyInfo().id as number);
}

export const isEnableFontPicker = () => {
  // 因为专项的代码已经推全smb了，包含了字体的功能了，所以这里直接返回true
  return true;
};

export const isEnableSmsCOICompany = () => {
  return true;
}

export const isEnableMultipleLanguages = () => {
  return [
    // 一期灰度
    30, 529, 3243, 2512, 2802,
    // 二期灰度全部SMB三方建站
    1791, 1790, 1827, 1828, 1860, 2671, 2512, 3001, 3029, 2626, 2670, 2111, 2696, 3203, 2541, 2373, 340, 341, 12, 718, 1501, 1650, 1507, 1509, 1917, 1864, 2040, 1499, 1834, 1500, 1620, 1816, 1817, 1845, 3026, 3033, 2751, 2221, 2079, 1974, 2205, 1505, 2527, 1516, 1515, 1927, 2275, 2423, 2533, 2114, 2738, 2525, 2453, 1582, 1837, 1924, 1333, 2802, 1767, 2084, 2764, 1354, 1534, 3074, 2983, 56, 3083, 2742, 1840, 2801, 3193, 29, 1863, 1819, 1833, 2719, 2339, 3014, 1508, 1588, 1532, 1818, 1043, 2071, 2693, 2380, 2231, 2544, 2509, 2604, 2741, 2710, 2740, 2955, 3112, 3115, 3127, 3139, 3149, 3164, 2080, 2528, 2496, 2357, 2039, 2567, 2247, 2341, 1960, 1992, 2038, 2099, 2410, 2031, 2036, 2013, 2020, 2009, 2032, 2033, 2035, 2019, 2024, 2025, 2001, 61, 1626, 2255, 2568, 2615, 2744, 2734, 2705, 2735, 2745, 2704, 2297, 1372, 1570, 3136, 2202, 1926, 2985, 3225, 2861, 3361, 3315, 2953, 3399, 3420, 3433, 3495, 3312, 3340, 3567, 2260, 2863, 2862, 2860, 2606, 1730, 1452, 1632, 1853, 1856, 1877, 2815, 2258, 2245, 1748, 71, 2237, 3059, 2378, 2382, 2822, 2534, 2002, 3223, 3144, 2787, 2135, 3303, 3261, 2438, 1560, 1543, 1538, 1843, 1825, 1537, 1677, 1586, 1697, 1961, 2261, 2226, 1601, 1815, 2565, 2605, 1976, 1962, 2061, 1540, 1887, 1988, 1844, 1888, 1523, 1542, 1841, 1539, 1541, 1680, 1683, 1826, 1832, 1914, 1963, 1965, 2000, 2824, 2780, 2758, 3276, 1842, 1629, 2094, 1628, 1590, 1647, 3052, 2823, 1276, 2342, 1327, 1311, 1063, 1479, 2585, 3123, 3128, 3129, 3130, 2660, 2577, 2601, 2737, 2736, 2663, 2763, 3249, 2241, 2905, 2546, 2554, 2555, 2547, 2690, 2550, 2788, 2803, 2851, 2798, 2819, 2820, 2869, 3260, 1228, 2004, 2566, 2594, 2595, 3375, 3500, 3502, 3505, 2723, 3277, 3493, 3497,
  ].includes(getCompanyInfo().id as number);
}

export const isEnableOnlyNewUserCustomStep = () => {
  return [30, 306, 621, 3243, 2512, 2802].includes(getCompanyInfo().id as number);
}

export const isEnableFlowTfnSend = () => {
  return getCompanyInfo().tfnSendOpen === true && isEnableSmsCOICompany();
};

/** 是否启用广告图模版校验图片 */
export const isEnableAdImageTemplateCheck = () => {
  return false;
}

export const isEnableSmsDoubleCheck = () => {
  const { smsDoubleCheck, smsDoubleCheckScope } = getCompanyInfo();
  return smsDoubleCheck === true && (smsDoubleCheckScope === 'all' || smsDoubleCheckScope?.includes('form'));
};

/** 是否支持easy-mail */
export const isEnableEasyMailEditor = (): boolean => {
  return (getCompanyInfo().emailEditorStatus === 1 || getCompanyInfo().emailEditorStatus === 3);
};
